import request from "@/utils/axios"

export function getFileImportResult(data) {
  return request({
    url: "/edu_basic/auth/get_file_import_result",
    method: "get",
    params: data,
  })
}
